import { escapeScript, restoreScript } from './dom';
export const safeSerialize = (context) => JSON.stringify(context, (key, value) => {
    if (typeof value !== 'string') {
        return value;
    }
    // Prevent inline script execution
    return escapeScript(value);
});
export const safeDeserialize = (context) => JSON.stringify(context, (key, value) => {
    if (typeof value !== 'string') {
        return value;
    }
    // Prevent inline script execution
    return restoreScript(value);
});
export const safeParse = (context) => {
    try {
        return JSON.parse(context);
    }
    catch (e) {
        return context;
    }
};
export const restoreScripts = (data) => {
    return JSON.parse(safeDeserialize(data));
};
